export default __webpack_public_path__ + "static/media/group-24px.eba63215.svg";